export const GET_LONG_LAT =
  'https://api.mapbox.com/geocoding/v5/mapbox.places/{address}.json?access_token=';

export const OPTIMIZE_TRIP =
  'https://api.mapbox.com/optimized-trips/v1/mapbox/driving/{address}?source=first&destination=last&overview=full&roundtrip=false&geometries=geojson&access_token=';

export const GET_DIRECTION = 'https://api.mapbox.com/directions/v5/mapbox/driving-traffic/';
